function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M99.418 137.567C78.3223 137.567 61.2208 120.714 61.2208 99.9241C61.2208 79.1345 78.3223 62.2812 99.418 62.2812",
  stroke: "#20205E",
  strokeWidth: 10.6597
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7871 103.296C85.1278 110.336 101.994 120.193 118.733 103.296",
  stroke: "#20205E",
  strokeWidth: 7.63892
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M163.166 92.911L163.166 140L156.277 140L156.277 92.911C150.804 90.9328 146.773 84.5401 146.773 76.8689C146.749 67.6296 152.563 60.1514 159.697 60.1514C166.88 60.1514 172.694 67.6296 172.67 76.8689C172.67 84.5401 168.639 90.9328 163.166 92.911Z",
  fill: "#20205E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.5858 139.849L35.3687 139.848L35.3431 89.9012L34.2683 89.8494C33.3229 89.8528 32.3863 89.6671 31.5123 89.303C30.6382 88.9389 29.8441 88.4037 29.1757 87.7281C28.5072 87.0525 27.9776 86.2499 27.6174 85.3665C27.2572 84.4832 27.0734 83.5365 27.0768 82.5811L27 60.0517L31.7346 60.0259L31.7858 76.8388L36.6484 76.7871L36.6228 60L41.3318 60L41.3062 76.7871L46.1688 76.8388L46.1943 60L50.9545 60.0517L50.8778 82.5811C50.8778 86.6162 47.6531 89.8753 43.6863 89.8494L42.6114 89.9012L42.5858 139.849Z",
  fill: "#20205E"
});

var SvgNoLogoLeft = function SvgNoLogoLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoLogoLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-logo-left.c53226cf.svg";
export { ForwardRef as ReactComponent };